import { MapPin, Clock, Anchor } from "lucide-react";
import { IMAGES, PUB } from "@/lib/data";

export default function Footer({ openingHours = "" }) {
  return (
    <footer className="bg-foreground text-background">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="bg-background rounded-2xl border-2 border-background p-4 inline-block">
            <img src={IMAGES.logoFull} alt="Harbour Haze Cafe Bar" className="h-40 w-40 object-contain" />
          </div>
          <p className="mt-6 text-background/70 max-w-sm">
            Bright coastal cafe bar, just up the hill from the Diamond Harbour ferry.
          </p>
        </div>

        <div className="md:col-span-4 space-y-4">
          <p className="overline text-primary">Find us</p>
          <p className="flex items-start gap-3"><MapPin size={18} className="text-secondary mt-0.5" /> {PUB.address}<br /></p>
          <p className="text-background/60 pl-8 -mt-3">{PUB.region}</p>
          <p className="flex items-center gap-3"><Anchor size={18} className="text-secondary" /> A short van ride from the jetty</p>
        </div>

        <div className="md:col-span-3 space-y-4">
          <p className="overline text-primary">Opening hours</p>
          <p className="flex items-center gap-3 font-mono-plex text-sm" data-testid="footer-opening-hours"><Clock size={16} className="text-secondary" /> {openingHours || "Open daily"}</p>
          <div className="flex flex-col gap-2 pt-2">
            <a href="#book-table" className="font-head font-bold hover:text-primary transition-colors">→ Book a table</a>
            <a href="#ferry" className="font-head font-bold hover:text-primary transition-colors">→ Ferry &amp; van lift</a>
            <a href="/admin/login" data-testid="footer-admin-link" className="font-mono-plex text-xs text-background/40 hover:text-background/70 transition-colors mt-2">Staff login</a>
          </div>
        </div>
      </div>
      <div className="border-t border-background/20">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2 font-mono-plex text-[11px] text-background/50">
          <span>© {new Date().getFullYear()} {PUB.name} Cafe Bar</span>
          <span>Ferry times via Metro Christchurch · Diamond Harbour, Aotearoa</span>
        </div>
      </div>
    </footer>
  );
}
